module.exports = __webpack_public_path__ + "img/active-1.c5121fb8.jpg";